export const init = {
  handle: "плоская",
  size: "25x32+10",
  color: "белый",
  face_colors: 1,
  rear_colors: 1,
  same_print: false,
  quantity: 200,
  quantity_manual: 0,
  min_quantity: 100,
  markups: [],
};
